export const grids = [
  {
    id: 1,
    label: "1 x 1",
    x: 1,
    y: 1,
  },
  {
    id: 2,
    label: "2 x 1",
    x: 2,
    y: 1,
  },
  {
    id: 3,
    label: "2 x 2",
    x: 2,
    y: 2,
  },
  {
    id: 4,
    label: "3 x 1",
    x: 3,
    y: 1,
  },
  {
    id: 5,
    label: "3 x 2",
    x: 3,
    y: 2,
  },
  {
    id: 6,
    label: "3 x 3",
    x: 3,
    y: 3,
  },
];
export const videoOptions = {
  controls: false,
  liveui: true,
  fluid: true,
  bigPlayButton: false,
};

export const dateConfig = {
  wrap: true,
  altFormat: "d F Y",
  altInput: true,
  dateFormat: "Y F d",
  maxDate: "today",
  defaultDate: "today",
};

export const timeConfig = {
  wrap: true,
  enableTime: true,
  enableSeconds: true,
  noCalendar: true,
  time_24hr: true,
  defaultDate: "today",
};
